import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getListArriveLateConfigSlice = createSlice({
  name: "getListArriveLateConfig",
  initialState,
  reducers: {
    getListArriveLateConfigStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListArriveLateConfigSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListArriveLateConfigFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetListArriveLateConfig: () => {
      return { ...initialState };
    },
  },
});

export const {
  getListArriveLateConfigStart,
  getListArriveLateConfigSuccess,
  getListArriveLateConfigFailed,
  resetListArriveLateConfig,
} = getListArriveLateConfigSlice.actions;

export default getListArriveLateConfigSlice.reducer;
